import React, { useState } from "react";
import { toast } from "react-toastify";

export type CopyToClipboardType = {
  text: string,
};
export default function CopyToClipboard(props: CopyToClipboardType) {
  const handleClick = () => {
    props.text && navigator.clipboard.writeText(props.text);
    toast.success("Text successfully copied to your clipboard.");
  };

  return (
    <div onClick={handleClick} className="material-icons pointer">
      content_copy
    </div>
  );
}
